/** Open a print dialog for HTML (Save as PDF in the browser). */

export function printHtmlDocument(title: string, bodyHtml: string): void {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.cssText =
    'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  document.body.appendChild(iframe);

  const win = iframe.contentWindow;
  const doc = iframe.contentDocument;
  if (!win || !doc) {
    iframe.remove();
    return;
  }

  const cleanup = () => {
    iframe.remove();
  };

  win.addEventListener('afterprint', cleanup);

  doc.open();
  doc.write(`<!DOCTYPE html>
<html lang="el">
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    @page { size: A4 landscape; margin: 10mm 10mm 14mm 10mm; }
    * { box-sizing: border-box; }
    body {
      margin: 0;
      font-family: "Segoe UI", Tahoma, Arial, sans-serif;
      font-size: 11px;
      color: #111827;
    }
    h1 { font-size: 16px; margin: 0 0 2px; }
    .subtitle { font-size: 12px; font-weight: 600; margin: 0 0 8px; }
    .meta { color: #4b5563; margin-bottom: 10px; }
    .summary {
      display: flex;
      gap: 12px;
      margin-bottom: 12px;
    }
    .summary-card {
      border: 1px solid #d1d5db;
      padding: 8px 12px;
      min-width: 160px;
    }
    .summary-card .label {
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: #6b7280;
    }
    .summary-card .row {
      display: flex;
      justify-content: space-between;
      gap: 16px;
      margin-top: 2px;
    }
    .sheet {
      min-height: 186mm;
      display: flex;
      flex-direction: column;
      page-break-after: always;
      break-after: page;
    }
    .sheet:last-child {
      page-break-after: auto;
      break-after: auto;
    }
    .running-head {
      font-size: 11px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    table { width: 100%; border-collapse: collapse; }
    th, td {
      border: 1px solid #d1d5db;
      padding: 4px 6px;
      text-align: left;
      vertical-align: top;
    }
    th {
      background: #f3f4f6;
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    td.num, th.num {
      text-align: right;
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
    }
    tfoot td { font-weight: 600; background: #f9fafb; }
    .sheet-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      margin-top: auto;
      padding-top: 6px;
      border-top: 1px solid #d1d5db;
      font-size: 10px;
      color: #4b5563;
    }
  </style>
</head>
<body>${bodyHtml}</body>
</html>`);
  doc.close();

  const triggerPrint = () => {
    win.focus();
    win.print();
  };

  if (doc.readyState === 'complete') {
    window.setTimeout(triggerPrint, 50);
  } else {
    iframe.addEventListener('load', () => window.setTimeout(triggerPrint, 50));
  }

  window.setTimeout(cleanup, 60_000);
}

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
